import React from 'react';
import { Outlet } from 'react-router-dom';
import AppFonts from './AppFonts';
import AppShell from './AppShell';
import { PageTitleProvider } from './PageTitleContext';
import { ThemeProvider } from './ThemeContext';
import { CompanyProvider } from './CompanyContext';
import '../../styles/app2.css';

/**
 * Layout de todas las rutas /app/*: aplica el wrapper `.as2` (que es donde viven
 * los tokens de color), carga las fuentes del rediseño y monta el shell.
 *
 * ── Modo de color ───────────────────────────────────────────────────────────
 * Durante la migración por fases la app estuvo fijada en claro, porque las
 * pantallas sin migrar se veían rotas en oscuro. Terminadas las pantallas, el
 * modo vuelve a ser el que elige la persona: AUTOMÁTICO por defecto, con
 * selector claro/automático/oscuro en el header y en Mi cuenta ▸ Preferencias.
 * La preferencia se comparte con la landing (misma llave `payslip-theme`), así
 * que el sitio público y la app se ven igual sin elegir dos veces.
 */
const AppLayout = () => (
  <div className="as2">
    <AppFonts />
    <ThemeProvider>
      <PageTitleProvider>
        <CompanyProvider>
          <AppShell>
            <Outlet />
          </AppShell>
        </CompanyProvider>
      </PageTitleProvider>
    </ThemeProvider>
  </div>
);

export default AppLayout;
